import {
  SPECTROGRAM_FFT_SAMPLES,
  SPECTROGRAM_MAX_FREQUENCY,
  SPECTROGRAM_MIN_FREQUENCY,
  WAVESURFER_PLAYBACK_HEIGHT,
} from 'app/views/alerts/components/event-noise-playback/wave-surfer-playback/WaveSurferConstants';
import { RefObject, useEffect } from 'react';
import SpectrogramPlugin from 'wavesurfer.js/dist/plugins/spectrogram.esm.js';
import { WaveSurferRef } from './types';
import { useColorMap } from './useColorMap';

export const useSpectrogram = ({
  spectrogramContainerRef,
  waveSurferRef,
}: {
  spectrogramContainerRef: RefObject<HTMLDivElement | null>;
  waveSurferRef: WaveSurferRef;
}) => {
  const waveSurfer = waveSurferRef.current;
  const spectrogramContainer = spectrogramContainerRef.current;
  const spectrogramColorMap = useColorMap();
  useEffect(() => {
    if (!spectrogramContainer) return;
    if (!waveSurfer) return;
    const spectrogram = waveSurfer.registerPlugin(
      SpectrogramPlugin.create({
        container: spectrogramContainer,
        colorMap: spectrogramColorMap,
        labels: true,
        frequencyMin: SPECTROGRAM_MIN_FREQUENCY,
        frequencyMax: SPECTROGRAM_MAX_FREQUENCY,
        fftSamples: SPECTROGRAM_FFT_SAMPLES,
        scale: 'logarithmic',
        height: WAVESURFER_PLAYBACK_HEIGHT,
      })
    );
    return () => spectrogram.destroy();
  }, [spectrogramContainer, spectrogramColorMap, waveSurfer]);
};
